module.exports = require("voca");